var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTablerDeviceIpadPlus = function SvgTablerDeviceIpadPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-hidden": "true",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-msbgid",
    focusable: "false",
    style: {
      fill: "none"
    },
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.417 17.5H5a1.667 1.667 0 0 1-1.667-1.667V4.167A1.667 1.667 0 0 1 5 2.5h10a1.667 1.667 0 0 1 1.667 1.667V10M7.5 15H10m3.333.833h5m-2.5-2.5v5"
  })));
};
export default SvgTablerDeviceIpadPlus;